import { ResidentStatus } from "@/enums/ResidentStatus";
import store from "@/store";

export const loadDataToStore = async () => {
  await store.dispatch("getResidentsShortData", ResidentStatus.ActiveResident);
  await store.dispatch("getGuestbookRules");
  await store.dispatch("getSocialClubs");
  await store.dispatch("getServiceRequests");
  await store.dispatch("getAdditionalServices");
  await store.dispatch("getLifestyleProgramCategories")
  await store.dispatch("getMaintenanceRequests")
}

